import React from 'react';

import Header from 'grommet/components/Header';
import Heading from 'grommet/components/Heading';
import Section from 'grommet/components/Section';
import Box from 'grommet/components/Box';

import Conditional from 'components/Conditional';

import Timings from './Timings';
import Manure from './Manure';

import {
  spring,
  fall,
  inSeason,
 } from 'containers/FieldSubmission';


const labels = {
  fall: 'Fall fertilizer applied',
  spring: 'Spring fertilizer applied',
  in_season: 'In season fertilizer applied',
}

export default function Applications(props) {
  const {
    name,
    state,
    heading,
    toggleSection,
    prefix,
  } = props;

  const FORMS = {
    spring: spring(prefix),
    fall: fall(prefix),
    in_season: inSeason(prefix),
  };

  const bgCalc = i => i % 2 === 0 ? 'light-1' : 'light-2';

  return (
    <Section pad="none">
      <Header
        pad={{ horizontal: 'medium', vertical: 'small' }}
        colorIndex="brand"
        className="sm-margin-top"
        direction="column" align="start">
        <Heading tag="h3" strong margin="none">{heading}</Heading>
        <Heading tag="h4" margin="none">Select all timings that apply.</Heading>
      </Header>
      <Section className="no-pad-top">
        {['fall', 'spring', 'in_season'].map((season, i) =>
          <Conditional
            key={season}
            id={name(`${season}`)}
            label={labels[season]}
            isOpen={state[`${prefix}_${season}`]}
            onChange={s => toggleSection(s, name(season), FORMS[season])}>
            <Box colorIndex={bgCalc(i)} pad="small" margin={{ vertical: 'small' }}>
              <Timings {...props} season={season} />
              <Manure display-if={season !== 'in_season'} {...props} season={season} />
            </Box>
          </Conditional>
        )}
      </Section>
    </Section>
  )
}



// WEBPACK FOOTER //
// ./src/components/Applications.js